import React, { useEffect, useState } from 'react'
import { responseError } from '../../../helpers/response/ResponseHelper'
import SupplyOrderTable from './SupplyOrderTable'
import { getSupplyOrdersAPI } from '../../../api/supply/supplyOrderAPI'
import { setSupplyOrdersCount, setSupplyOrdersLimit, setSupplyOrdersList, setSupplyOrdersOffset } from '../../../store/supplyOrderSlice'
import { useDispatch, useSelector } from 'react-redux'
import ErrorMessage from '../../UI/messages/ErrorMessage'

const SupplyOrderList = () => {

    const supplyOrders = useSelector(state => state.supplyOrder.supplyOrders.list)
    const count = useSelector(state => state.supplyOrder.supplyOrders.count)
    const limit = useSelector(state => state.supplyOrder.supplyOrders.limit)
    const offset = useSelector(state => state.supplyOrder.supplyOrders.offset)
    const query = useSelector(state => state.supplyOrder.supplyOrders.query)
    const status = useSelector(state => state.supplyOrder.supplyOrders.filters.status)
    const departmentId = useSelector(state => state.supplyOrder.supplyOrders.filters.departmentId)
    const agreeDirector = useSelector(state => state.supplyOrder.supplyOrders.filters.agreeDirector)
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        
        // Функція для затримки
        const handler = setTimeout(() => {
            getSupplyOrders()
        }, 300) // 300 мс затримки

        return () => clearTimeout(handler)

    }, [limit, offset, query, status, departmentId, agreeDirector])

    const getSupplyOrders = () => {
        setLoading(true)
        setError('')
        getSupplyOrdersAPI({ offset, limit, query, status, departmentId, agreeDirector }).then(data => {
            dispatch(setSupplyOrdersCount(data.count))
            dispatch(setSupplyOrdersList(data.supplyOrders))
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div>
        <ErrorMessage error={error} />
        
        <SupplyOrderTable
            supplyOrders={supplyOrders}
            count={count}
            limit={limit}
            setLimit={e => dispatch(setSupplyOrdersLimit(e))}
            offset={offset}
            setOffset={e => dispatch(setSupplyOrdersOffset(e))}
            loading={loading}
        />
    </div>
  )
}

export default SupplyOrderList